"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var ArrowForward_1 = __importDefault(require("@mui/icons-material/ArrowForward"));
var ArrowBack_1 = __importDefault(require("@mui/icons-material/ArrowBack"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var ShareVacancyTab = function () {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [trans_1.default.get('entities.shared_vacancies'), " ", (0, jsx_runtime_1.jsx)(ArrowForward_1.default, {})] }));
};
var ChatTab = function () {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ArrowBack_1.default, {}), " ", trans_1.default.get('entities.messages')] }));
};
function CurrentTab(_a) {
    var tab = _a.tab;
    if (tab === 0) {
        return (0, jsx_runtime_1.jsx)(ShareVacancyTab, {});
    }
    return (0, jsx_runtime_1.jsx)(ChatTab, {});
}
exports.default = CurrentTab;
